/*用户状态*/
import {
  setSessionStorage
} from '@/utils/base'
import getRolelist from './getRolelist.js'
import {
  errpage
} from '@/router/baseRouter.js'

import {
  cearedRoute
} from './cearedRoute.js'
import {
  createdAuth
} from '@/utils/createdAuth'


const user = {

  namespaced: true,

  /*状态值*/
  state: {
    roles: null,
    page: null
  },

  /*状态值转换*/
  getters: {

    getroles: (state) => (name) => {
      return state.roles;
    },

  },

  /*改变状态的方法 不可异步*/
  mutations: {

    setState(state, value) {
      state[value.key] = value.val;
    },

    saveMenulist(state, value) {
      state.getters.menulist = value;
    }

  },

  /*可异步改变*/
  actions: {

    generateRoutes: function(context) {
      // 应用初始化时读取最新菜单；页面内导航由 permission.js 的内存状态复用。
      // sessionStorage 仅供侧栏和按钮读取，不作为菜单是否更新的依据。
      return getRolelist().then(rolelist => {
        const routes = cearedRoute(rolelist).concat(errpage);
        const authlist = {};
        createdAuth(rolelist, authlist);
        setSessionStorage('rolelist', rolelist);
        setSessionStorage('authlist', authlist);
        context.commit('setState', {
          key: 'roles',
          val: rolelist
        });
        return routes;
      });
    }

  }
}


export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js